module.exports = __webpack_public_path__ + "media/flags/gn-afea6cea.svg";